import https from './http.js';
	
	let apiFun = {};
	
	apiFun.get = function(url,params) {
		return https.get(url, params)
	}
	
    apiFun.post = function(url,params) {
		return https.post(url, params)
	}
    apiFun.login = function(params) {
		return https.post('/api/login_pc', params)
	}
	apiFun.register = function(params) {
		return https.post('/api/register', params)
	}
	export default apiFun;




// WEBPACK FOOTER //
// ./src/http/api.js